import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./Common/styles/shine-animations.css";
import "./Common/styles/enhanced-animations.css";
import App from "./App";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import MuiThemeProvider from "./Common/Theme-Provider/MuiThemeProvider";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <MuiThemeProvider>
      <App />
    </MuiThemeProvider>
  </React.StrictMode>
);

serviceWorkerRegistration.register();